import { motion } from "framer-motion";

export function PointsBubble({ value, size = "md", testid }) {
  const dims = size === "lg" ? "min-w-10 h-10 text-lg" : "min-w-8 h-8 text-sm";
  return (
    <motion.span
      key={value}
      data-testid={testid}
      initial={{ scale: 0.6 }}
      animate={{ scale: [1.2, 1] }}
      transition={{ type: "spring", stiffness: 500, damping: 15 }}
      className={`${dims} px-2 rounded-full flex items-center justify-center font-extrabold text-white shadow-md ring-2 ring-white dark:ring-card z-40 ${value >= 0 ? "bg-emerald-500" : "bg-red-500"}`}
    >
      {value}
    </motion.span>
  );
}
